import {BaseViewModel} from "../../../infrastructure/models/base-view-model";

export class PositionViewModel extends BaseViewModel {
  get shortName(): String {
    return this.apiModel.shortName;
  }
}
